// Window Load Event
window.addEventListener('load', initializeTelInputs);

export function initializeTelInputs()
{
    document.querySelectorAll('input[type="tel"]').forEach(
        e => e.addEventListener('input', onTelInput)
    );
}

export function onTelInput(event: Event)
{
    const target = event.target as HTMLInputElement;
    const { value } = target;

    const numbersOnly = value.replaceAll(/\D/g, '');

    // Get area code
    let newValue = numbersOnly.substring(0, 3);

    if (numbersOnly.length <= 3)
    {
        target.value = newValue;
        return;
    }

    // Get exchange
    const exchange = numbersOnly.substring(3, 6);
    newValue += `-${exchange}`;

    if (numbersOnly.length <= 6)
    {
        target.value = newValue;
        return;
    }

    // Get remaining digits
    const digits = numbersOnly.substring(6, 10);
    newValue += `-${digits}`;

    target.value = newValue;
}
